export default "__VITE_ASSET__B1UuVY$0__"